/**
 * Purpose:
 * Centralized route definitions for Send Money workflow.
 */
export const SEND_MONEY_ROUTES = {
    PHONE: "/sendMoney/phone",
    PIN: "/sendMoney/pin",
    COUNTRY: "/sendMoney/country",
    STATE: "/sendMoney/state",
    AMOUNT: "/sendMoney/amount",
    HOW_THEY_RECEIVE: "/sendMoney/how-they-receive",
    REVIEW_AND_EDIT: "/sendMoney/review-and-edit",
    SENDER_INFO: "/sendMoney/sender-info",
    SENDER_ADDRESS: "/sendMoney/sender-address",
    SENDER_DOB: "/sendMoney/sender-dob",
    SENDER_ID1: "/sendMoney/sender-id-1",
    SENDER_ID2: "/sendMoney/sender-id-2",
    RECEIVER_INFO: "/sendMoney/receiver-info",
    ADDITIONAL_INFO: "/sendMoney/additional-info",
    FRAUD_PREVENTION: "/sendMoney/fraud-prevention",
    FINAL_REVIEW: "/sendMoney/final-review",
    HEAD_TO_CASHIER: "/sendMoney/head-to-cashier",
  } as const;